import React, {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import logotexto from './../assets/images/logotipo.jpg'
import ValidarCorreoElectronico from '../functions/ValidarCorreoElectronico';
import ValidarUsuario from '../functions/ValidarUsuario';

// Store de admin
import adminStore from '../store/admin';

// para manipular las rutas con wouter
import { navigate } from "wouter/use-browser-location";
import { useLocation } from 'wouter';

function Login() {
  
    // Variables del store de admin
    const {usuarioEmail, setUsuarioEmail} = adminStore();
    const {usuarioNombre, setUsuarioNombre} = adminStore();
    const {usuarioApellido, setUsuarioApellido} = adminStore();
    const {usuarioNivel, setUsuarioNivel} = adminStore();
    const {usuarioId, setUsuarioId} = adminStore();
    const {usuarioCelular, setUsuarioCelular} = adminStore();

    // Variables de estado locales
    const [errorLogin, setErrorLogin] = useState(false);
    const [valorEmail, setValorEmail] = useState('');
    const [valorClave, setValorClave] = useState('');

    const resetearFormulario = () => {
        setErrorLogin(false);
        setValorEmail('');
        setValorClave('');
        const email = document.getElementById('email');
        email?.focus();
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const email = data.get('email');
        const password = data.get('password') || '';

        if (ValidarCorreoElectronico(email as string)) {
            if (password && typeof password === 'string' && password.trim().length > 0) {
                const respuesta = await ValidarUsuario(email as string, password);
                if (respuesta && respuesta.usuario_ok === "si") {
                    setErrorLogin(false);
                    // Guardar los datos del usuario en el store
                    setUsuarioEmail(respuesta.usuario.user_email);
                    setUsuarioNombre(respuesta.usuario.user_forename);
                    setUsuarioApellido(respuesta.usuario.user_surname);
                    setUsuarioNivel(respuesta.usuario.user_level);
                    setUsuarioId(respuesta.usuario.user_id);
                    setUsuarioCelular(respuesta.usuario.user_celular);

                    // Redirigir a la página de administración
                    navigate('/admin');

                } else {
                    setErrorLogin(true);
                }

            }
        }
    };

    return (
        <div className='container-fluid flex flex-col items-center justify-center h-dvh'>
            <div className="flex flex-col justify-center items-center bg-white border-2 rounded-lg border-vp-plan-5 shadow-xl shadow-vp-gris xxs:mx-6 xs:mx-6 min-w-[280px]">
                <div className="flex flex-col justify-center items-center p-6 xxs:p-3 xs:p-3 sm:p-3 max-w-sm">
                    <img src={logotexto} className="w-[200px]" alt="VidaPlus Logo" />
                    <h3 className="font-myriad-pro font-regular text-lg mt-4">
                        Área de Administración - Ingresar
                    </h3>
                    <form onSubmit={handleSubmit} noValidate>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Correo electrónico"
                            name="email"
                            autoComplete="email"
                            type="email"
                            value={valorEmail}
                            onChange={(e) => setValorEmail(e.target.value)}
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Clave"
                            type="password"
                            id="password"
                            value={valorClave}
                            onChange={(e) => setValorClave(e.target.value)}
                            autoComplete="current-password"
                        />
                        {errorLogin && (<div className="flex flex-col justify-center items-center mt-2">
                            <h3 className="font-metropolis font-regular text-sm text-red-900">Datos de inicio de sesión incorrectos.</h3>
                        </div>)}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 2, mb: 1 }}
                        >
                        Ingresar
                        </Button>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 1, mb: 2, backgroundColor: '#f44336', color: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#ff7961', // Cambia el color de fondo al pasar el mouse
                                    color: '#ffffff', // Opcional: Cambia el color del texto al pasar el mouse
                                },
                            }}
                            onClick={resetearFormulario}
                        >
                        Limpiar
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;